import { TranslationValues } from "next-intl";
import { TFunction } from "../type";

/**
 * CRUD / permission tables mix i18n keys (`common.name`) with raw module names
 * (`CargoGo Admin`). Only translate dotted keys — plain labels render as-is.
 */
export function translateLabel(t: (key: string) => string, label: string): string {
  if (!label || !label.includes(".")) {
    return label;
  }
  try {
    return t(label);
  } catch {
    return label;
  }
}

export const parseIntlJSON = (t: TFunction, message?: string) => {
  if (!message) {
    return "";
  }
  try {
    const data = JSON.parse(message);
    const { key, ...params } = data;
    const translated = Object.fromEntries(
      Object.entries(params).map(([key, value]) => [
        key,
        typeof value === "string" ? t(value).toLowerCase() : value,
      ]),
    ) as TranslationValues;
    return t(key, translated);
  } catch (e) {
    return message;
  }
};
